import { StrapiBlogProps } from '@/types/strapiBlog';
import s from './strapiBlog.module.scss';
import Image from 'next/image';
import BreadCrumbsBlog from '../BreadCrumbsBlog/BreadCrumbsBlog';
import { sanitizeBlogHtml } from '@/utils/sanitizeBlogHtml';
import HeroBlock from '../HeroBlock/HeroBlock';
import heroStyles from '../HeroBlock/hero-block.module.scss';
import { strapiBlogPageHeroConfig } from '@/config';

const wrapTables = (html: string, className: string) =>
  html.replace(
    /<table\b[\s\S]*?<\/table>/gi,
    (table) => `<div class="${className}">${table}</div>`
  );

const StrapiBlog = ({ post }: { post: StrapiBlogProps }) => {
  const sanitizedContent = wrapTables(
    sanitizeBlogHtml(post?.text, 'article'),
    s.tableScroll
  );

  return (
    <>
      <section className="container">
        <BreadCrumbsBlog item={post?.title} />
        <div className={s.strapiBlog}>
          <div className={s.blogHeader}>
            <Image
              src={
                post.cover.url.startsWith('http')
                  ? post.cover.url
                  : `https://blog.heraflight.com${post.cover.url}`
              }
              alt={post?.cover?.alternativeText ?? 'picture'}
              width={700}
              height={700}
              unoptimized
              className={s.blogCoverImage}
            />
            {/* <div className={s.blogHeaderContent}>
            <h1 className={s.title}>{post?.title}</h1>
            <div className={s.blogDescription}>{post?.description}</div>
          </div> */}
          </div>

          <div className={s.strapiBlogContent}>
            <div
              dangerouslySetInnerHTML={{ __html: sanitizedContent }}
              className={s.content}
            />
          </div>
        </div>
      </section>
      <HeroBlock
        {...strapiBlogPageHeroConfig}
        className={heroStyles.strapiBlogHero}
      />
    </>
  );
};

export default StrapiBlog;
